import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { PromoCtaWrap } from './PromoCtaButton.styles';

export { PromoCtaWrap } from './PromoCtaButton.styles';
export { PromoCtaButton } from './PromoCtaButton.styles';

/** 결과 페이지 CTA — 위치는 PromoCtaWrap 과 동일, 등장은 opacity만 (transform 충돌 방지) */
export const PromoCtaWrapAnimated = styled(PromoCtaWrap)<{ $visible?: boolean }>`
  opacity: 0;
  transition: opacity 0.42s cubic-bezier(0.34, 1.45, 0.64, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  ${(p) =>
    p.$visible &&
    css`
      opacity: 1;
    `}
`;
